import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/springbackMaintenance/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/maintenanceHistory/save'
export function queryPage1(data) {
  return request({
    url: '/icps/system/sign/intelligent/maintenanceHistory/queryPage',
    method: 'post',
    data
  })
}